/* Extra curated reviews, weighted to the US — the biggest market and the one
   a US visitor scans for before trusting the store. Merged into the widget's
   own list on load, and into the stored copy so they survive a reload. */
(function(){
var EXTRA=[
{r:5,n:'Brandon K.',l:'Colorado, United States',d:0,t:'Vail lift line went silent then lost it',b:'Pulled it up in the Gondola One line at Vail and the entire queue turned around. Two guys asked me for the link right there on their phones. Warm enough for a bluebird twenty degree day.',p:'$48.95',pm:'shoppay',av:0,hy:11,hn:0},
{r:5,n:'Ashley P.',l:'Utah, United States',d:1,t:'Bought it for my husband, he has not taken it off',b:'Park City trip, he wore it four days straight including to dinner once. Our friends have ordered two more between them. It is the funniest thing we own.',p:'$64.95',pm:'visa',av:3,hy:8,hn:0},
{r:5,n:'Derek W.',l:'Vermont, United States',d:2,t:'Handles real East Coast cold',b:'Killington in January is not a joke and this sealed the neck gap completely. Thin enough under the helmet, no fogging on the goggles all day.',p:'$27.95',pm:'mastercard',av:6,hy:6,hn:0},
{r:4,n:'Megan T.',l:'California, United States',d:3,t:'Great mask, wanted it a day sooner',b:'Tahoe trip and it landed the morning we left, which was cutting it close. Product is exactly as shown and I would order again, just earlier next time.',p:'$48.95',pm:'paypal',av:9,hy:4,hn:1},
{r:5,n:'Chris A.',l:'Montana, United States',d:4,t:'Ski patrol asked where I got it',b:'Big Sky, middle of a lift evac drill, and patrol stopped to ask about the mask. Ended up giving three of them the link. Sturdy knit, holds shape after a wash.',p:'$27.95',pm:'shoppay',av:2,hy:9,hn:0},
{r:5,n:'Jordan M.',l:'Washington, United States',d:6,t:'Crystal Mountain regulars know me by it now',b:'I have become the guy with the face. People wave at me from the chair. Best twenty eight dollars I have spent on a season.',p:'$27.95',pm:'visa',av:5,hy:7,hn:0},
{r:5,n:'Nicole B.',l:'New York, United States',d:8,t:'Gifted three, all three are in use',b:'Christmas presents for my brothers. All three wore them to Hunter the following week and sent me videos. Shipping to NY took five days.',p:'$64.95',pm:'shoppay',av:7,hy:5,hn:0},
{r:4,n:'Sean D.',l:'Idaho, United States',d:11,t:'Excellent, just want more faces',b:'Sun Valley loved it. Only reason for four stars is that I already own two of the three designs and want new ones. Please make more.',p:'$48.95',pm:'mastercard',av:1,hy:3,hn:0}
];

var LSR='iffrv1';
function dl(off){if(off===0)return 'Today';if(off===1)return 'Yesterday';if(off<7)return off+' days ago';if(off<30)return Math.floor(off/7)+' weeks ago';return Math.floor(off/30)+' months ago';}

function merge(){
var raw;
try{raw=localStorage.getItem(LSR);}catch(e){return false;}
if(!raw)return false;
var list;
try{list=JSON.parse(raw);}catch(e){return false;}
if(!list||!list.length)return false;
if(list.some(function(r){return r.id==='us0';}))return true;
var now=Date.now(), dm=86400000;
EXTRA.forEach(function(x,i){
list.push({id:'us'+i,r:x.r,n:x.n,l:x.l,t:x.t,b:x.b,p:x.p,reply:null,av:x.av,pm:x.pm,ts:now-(x.d*dm),date:dl(x.d),hy:x.hy,hn:x.hn});
});
list.sort(function(a,b){return b.ts-a.ts;});
try{localStorage.setItem(LSR,JSON.stringify(list));}catch(e){}
return true;
}

var n=0;
var iv=setInterval(function(){
n++;
if(merge()||n>40)clearInterval(iv);
},200);
})();
